'use strict';

var React = require('react');
var Button = require('../../Inputs/Buttons/Button/Button.js');
require('prop-types');
var Typography = require('../Typography/Typography.js');
var ObjectHelper = require('../../../common/ObjectHelper.js');
var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Toolbar = require('../../../node_modules/@material-ui/core/esm/Toolbar/Toolbar.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  title: {
    flex: '1 1 90%'
  },
  root: {
    padding: '16px 24px 0px 24px',
    minHeight: 0
  }
};

var TableToolbar = function TableToolbar(props) {
  var title = props.title,
      actionButtonText = props.actionButtonText,
      classes = props.classes,
      onActionButtonClicked = props.onActionButtonClicked;
  return React__default["default"].createElement(Toolbar["default"], {
    classes: {
      root: classes.root
    }
  }, React__default["default"].createElement(Typography, {
    variant: 'h3',
    className: classes.title
  }, title), ObjectHelper.isPresent(actionButtonText) && ObjectHelper.isPresent(onActionButtonClicked) && React__default["default"].createElement(Button["default"], {
    color: 'primary',
    onClick: function onClick() {
      return onActionButtonClicked();
    }
  }, actionButtonText));
};

var TableToolbar$1 = withStyles(styles)(TableToolbar);

module.exports = TableToolbar$1;
